document.documentElement.classList.remove('no-js');

const q = (selector, scope = document) => scope.querySelector(selector);
const qa = (selector, scope = document) => [...scope.querySelectorAll(selector)];

document.addEventListener('click', (event) => {
  const menuButton = event.target.closest('[data-menu-toggle]');
  if (menuButton) {
    const nav = q('#MobileNav');
    const open = nav.classList.toggle('is-open');
    menuButton.setAttribute('aria-expanded', String(open));
    document.body.classList.toggle('locked', open);
  }

  const accordion = event.target.closest('[data-accordion-trigger]');
  if (accordion) {
    const item = accordion.closest('.accordion');
    const open = item.classList.toggle('is-open');
    accordion.setAttribute('aria-expanded', String(open));
  }
});

qa('[data-product-form]').forEach((form) => {
  form.addEventListener('submit', async (event) => {
    event.preventDefault();
    const button = q('[type="submit"]', form);
    const original = button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING…';
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      if (!response.ok) throw new Error('Unable to add item');
      const cart = await fetch(window.Shopify.routes.root + 'cart.js').then((r) => r.json());
      qa('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
      button.textContent = 'ADDED ✓';
      setTimeout(() => { button.textContent = original; button.disabled = false; }, 1300);
    } catch (error) {
      button.textContent = 'TRY AGAIN';
      button.disabled = false;
    }
  });
});

const revealObserver = new IntersectionObserver((entries) => {
  entries.forEach((entry) => { if (entry.isIntersecting) entry.target.classList.add('is-visible'); });
}, { threshold: 0.12 });
qa('[data-reveal]').forEach((el) => revealObserver.observe(el));
